import React from 'react';
import styled from 'styled-components'
import PrivateEyeViewReactTable from './PrivateEyeViewReactTable';
//import rows from './rows.json';
//import columns from './columns.json';
import rows from './rows-bushmill.json';
import columns from './columns-bushmill.json';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../autocode/AutocodeLabelsGenerator';
import { uniqueId } from 'lodash-es';


const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);

const CrosstabTable = () => {

  const Styles = styled.div`
  padding: 1rem;

  .table {
    display: inline-block;
    background: #FFFFFF;
    /* Lines and Borders */
    
    border: 2px solid #DEDEDE;
    box-sizing: border-box;
    border-radius: 0px;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }
    .tr {
        .td, .th {
          :first-child {
            color: #000
            //styleName: Body Bold 14px - Title, Links;
             font-family: "Open Sans";
             font-size: 12px;
             font-style: normal;
             font-weight: 700;
             line-height: 17px;
             letter-spacing: 0.10000000149011612px;
             text-align: left; 
          }
        }
      }

      .tr {
        .td, .th {
          //styleName: Body Reg 14px - Text;
          font-family: "Open Sans";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 17px;
          letter-spacing: 0.25px;
          text-align: left;
          
        }
      }

    .tr{
      :first-child {
        .th {
           color: #000
           //styleName: Body Bold 14px - Title, Links;
            font-family: "Open Sans";
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: 17px;
            letter-spacing: 0.10000000149011612px;
            text-align: left;

        }
      }
    }

    .th,
    .td {
      margin: 0;
      padding: 0.5rem;
      border: 1px solid #DEDEDE;
      background-color: #fff;
      overflow: hidden;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    }
    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }
 
      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }
 
      .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
      }
 
      .body {
        position: relative;
        z-index: 0;
      }
 
      [data-sticky-td] {
        position: sticky;
      }
 
      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }
 
      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }
`
  const totalRowCellList = rows && rows.length > 0 ? rows[0].cellList: [];
  const DEFAULT_CELL_ELEMENTS = [
    {
      key: 'sample',
      isVisible: true,
      label: 'Unweig',
    },
    {
      key: 'weighted',
      isVisible: true,
      label: 'weight',
    },
    {
      key: 'vertical',
      isVisible: true,
      label: 'Vertic',
    },
    {
      key: 'horizontal',
      isVisible: true,
      label: 'Hor',
    },
    {
      key: 'index',
      isVisible: true,
      label: 'Index',
    },
  ];
  const partsToShow = {
    showCat: true,
    showSCats: true,
    showQ: true,
    showA: true,
  };
  const isVisibleCount =  DEFAULT_CELL_ELEMENTS.filter((cell) => cell.isVisible).length;
  const buildMetricsHeaders = (index) =>{
    const cols = [];
    const width = 298/isVisibleCount;
    DEFAULT_CELL_ELEMENTS.map(cell => {
      if(cell.isVisible) {
        cols.push({
          Header: () => { return <React.Fragment>
            <div>{cell.label}</div>
            <div>{totalRowCellList[index][`${cell.key}`]}</div>
            </React.Fragment> },
          accessor : `col_${index}_${cell.key}`,
          width,
        });
      }
    });
    return cols;
  }

 const buildPrivateViewColumns = () => {
   const tableColumns = [];
   tableColumns.push({
     Header: '',
     id: uniqueId(),
     sticky: 'left',
     columns: [{
      Header: 'All',
      accessor: 'rowName',
      width: 218,
     }]
     
   });
   tableColumns.push({
    Header: 'All',
    id: uniqueId(),
    columns: buildMetricsHeaders(0),
  });
  columns.map((col, index) => {
    const header = toLabelString(col.autocodenode, partsToShow, true);
    tableColumns.push({
      Header: header.substring(0, 150),
      id: uniqueId(),
      columns: buildMetricsHeaders(index + 1),
    })
  });
  return tableColumns;
 }

 const buildPrivateViewRows = () => {
   function makeRow(row) {
     let tableRow = {};
     tableRow['rowName'] = row.autocodenode ? toLabelString(row.autocodenode, partsToShow, true).substring(0, 150): '';
      row.cellList.map((rowCell, index)=> {
        DEFAULT_CELL_ELEMENTS.map(cell => {
          if(cell.isVisible) {
            tableRow[`col_${index}_${cell.key}`] = rowCell[`${cell.key}`];
          }
        });
      });
      return tableRow
   }
  
   const tableRows = [];
   rows.map((row, index) => {
     if (index > 0) {
      tableRows.push(makeRow(row));
     }
   });
   return tableRows;
 }

const pvColumns = React.useMemo(() => buildPrivateViewColumns(), []);
const pvRowData = React.useMemo(() => buildPrivateViewRows(), []);

  return (
    <div>
      <Styles>
          <PrivateEyeViewReactTable  columns={pvColumns} data={pvRowData}  className="-striped -highlight" />
      </Styles>
    </div>
  )
}

export default CrosstabTable